import React from 'react';
import dynamic from 'next/dynamic';
import { Container, Typography, Box } from '@mui/material';
import { useStyles } from './styles';

const DynamicCircularCarousel = dynamic(() => import('components/CircularCarousel'));

const carouselAnniversary = [
  {
    image: '/images/graphical-abstract-slide-1.jpg',
    description:
      'How the pinel gland works, the enigmatic organ thath regulates our sleep. BBC News Brazil.',
    id: 1,
    width: '336',
    height: '188',
  },
  {
    image: '/images/graphical-abstract-slide-2.jpg',
    description:
      'Londono-Renteria, B., Cardenas, J. C., Troupin, A. & Colpitts, T. M. Natural Mosquito-Pathogen Hybrid IgG4 Antibodies in Vector-Borne Diseases: A Hypotesis. Frontiers in Immunology 7, 380 (2016)',
    id: 2,
    width: '336',
    height: '192',
  },
  {
    image: '/images/graphical-abstract-slide-3.jpg',
    description:
      'Cortabarria, A. S. de V. et al. In Utero Therapy for the Treatment of Sickle Cell Disease: Taking Advantage of the Fetal Immune System. From Cell Dev Biol 8, 624477 (2021).',
    id: 3,
    width: '336',
    height: '245',
  },
  {
    image: '/images/graphical-abstract-slide-4.jpg',
    description:
      "Scorza, F. A. et al. Sudden death in a rat model of Parkinson's disease. Clinics, 76, (2021)",
    id: 4,
    width: '336',
    height: '309',
  },
  {
    image: '/images/graphical-abstract-slide-5.jpg',
    description:
      'Rather, I. A., Lone, J. B., Bajpai, V. K. & Park, Y.-H. Zika Vírus Infection during Pregnancy and Congenital Abnormalities. Front Microbiol 8, 581 (2017).',
    id: 5,
    width: '336',
    height: '226',
  },
  {
    image: '/images/graphical-abstract-slide-6.jpg',
    description:
      'Babacic, H., Mehta, A., Merkel, O. & Schoser, B. CRISPR-cas gene-editing as plausible treatment of neuromuscular and nucleotide-repeat-expansio n diseases: A systematic review, PLos One 14, e0212198 (2019).',
    id: 6,
    width: '336',
    height: '256',
  },
];

export default function CarouselAnniversary({ isJournalOrNotAvailableForPromotion }) {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.statSection}>
        <Container>
          <Box>
            <Container>
              <Box mb={6} textAlign="center">
                <Typography className={classes.darkColor} variant="h4" component="h2">
                  Papers with Graphical Abstracts have
                </Typography>
              </Box>

              <div className={classes.infoContent}>
                <div className={classes.infoBox}>
                  <Typography className={classes.gradientStat} variant="h3">
                    <b>3x</b>
                  </Typography>
                  <Typography>more downloads</Typography>
                </div>

                <div className={classes.infoBox}>
                  <Typography className={classes.gradientStat} variant="h3">
                    <b>15x</b>
                  </Typography>
                  <Typography>more citations</Typography>
                </div>

                <div className={classes.infoBox}>
                  <Typography className={classes.gradientStat} variant="h3">
                    <b>8x</b>
                  </Typography>
                  <Typography>
                    more shares on <br /> social media
                  </Typography>
                </div>

                <div className={classes.infoBox}>
                  <Typography className={classes.gradientStat} variant="h3">
                    <b>4.8x</b>
                  </Typography>
                  <Typography>more retweets</Typography>
                </div>
              </div>
            </Container>
          </Box>
        </Container>
      </Box>

      <Box className={classes.carouselSection}>
        <Container>
          <Typography className={classes.darkColor} variant="h4" component="h2" align="center">
            Made with Mind the Graph
          </Typography>

          <DynamicCircularCarousel
            classes={{
              root: classes.carouselRoot,
              carousel: classes.carousel,
              carouselItem: classes.carouselItem,
            }}
            autoplay={true}
            controlButtons={false}
            items={carouselAnniversary.map((carouselAnniversary) => (
              <Box key={carouselAnniversary.id} className={classes.carouselContent}>
                <img
                  src={carouselAnniversary.image}
                  alt={carouselAnniversary.description}
                  loading="lazy"
                  height={carouselAnniversary.height}
                  width={carouselAnniversary.width}
                />

                <Typography variant="body2">{carouselAnniversary.description}</Typography>
              </Box>
            ))}
          />
        </Container>
      </Box>
    </>
  );
}
